import { setPlaceModules } from './unitNavigation'
import { salvarPlanoNaSessao } from './planos'

// ─────────────────────────────────────────────────────────────────────────────
//  SESSÃO DE UMA UNIDADE NO NAVEGADOR
//
//  O que o painel lê do localStorage para abrir uma unidade (plano, PDV, DDD,
//  regras de campanha, módulos). Vinha do Login.js; mora aqui porque o fim do
//  cadastro self-serve (/onboarding) também abre o painel direto — e as duas
//  portas precisam gravar EXATAMENTE as mesmas chaves.
// ─────────────────────────────────────────────────────────────────────────────

// Plano: o nalp e os direitos (`dir`) saem de ./planos — códigos novos
// (gerente_ia…super) e antigos (basic…premium_b), com o módulo de Disparo B.

export function salvarDadosDaUnidade(places) {
    localStorage.setItem("tabPath", "home")
    localStorage.setItem("viewType", "user")
    localStorage.setItem("nim", places.camp_miss_you_min_days)
    localStorage.setItem("xam", places.camp_miss_you_max_days)
    localStorage.setItem("act", places.camp_active_days)
    localStorage.setItem("pdv", places.pdv)
    setPlaceModules(places)
    // (loja de contrato que voltou pelo portal pode não ter o telefone cadastrado)
    localStorage.setItem("ddd", String(places.phone || '').slice(3, 5))
    localStorage.setItem("place_name", places.name)
    localStorage.setItem("camp", "")
    salvarPlanoNaSessao(places)
    localStorage.setItem("TAG", places.import_data_tag)
    // loja do cadastro self-serve: libera "Minha assinatura" e o aviso de atraso
    localStorage.setItem("ss", places.origem === 'self_serve' ? '1' : '')
}
